module.exports = __webpack_public_path__ + "static/media/loan-against-property.489af6dd.jpg";